/** Official artist destinations — the single source of truth for the four platform links everywhere on the site. */
export const OFFICIAL_LINKS = {
  apple_music: "https://music.apple.com/us/artist/okaytwitchy/1804885659",
  spotify: "https://open.spotify.com/artist/0AkuFlvwiBSU99gGqfEXgL",
  youtube: "https://youtube.com/@okaytwitchyy",
  instagram: "https://www.instagram.com/okaytwitchy",
};
